const zIndexes = {
    hotspot: 1,
};

export default zIndexes;
